export default "__VITE_ASSET__C3DNJc4j__"